/**
 * Definition of all routes of the application.
 */
export const routes = {
  search: {
    url: 'search',
    absoluteUrl: '/search',
  },
  compare: {
    url: 'compare',
    absoluteUrl: '/compare',
  },
  edit: {
    url: 'edit',
    absoluteUrl: '/edit',
  },
  unhandledError: {
    url: 'serverunhandlederror',
    absoluteUrl: '/serverunhandlederror',
  },
};
